import { defineStore } from 'pinia'

const useFeatureFlagsStore = defineStore('featureFlagsStore', {
  state: () => ({}),
})

export default useFeatureFlagsStore
